var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ExpedienteCreateComiteView',{attrs:{"prefix-create-path":"case_file/court_resolution/"}})}
var staticRenderFns = []

export { render, staticRenderFns }